import { Trans } from '@lingui/macro';
import _ from 'lodash';

import { useTooltipStyles } from '../ChartTooltipStyles';
import { chartDefFormatter } from '../Formatters';
import { getStatusColor } from '../../../../utilities/StatusUtilities';

const filterOutStatusBreakout = (chartDef, item) => {
    if (!chartDef.statusBreakout) return true;
    if (item.def.key === 'blank') return false;
    return _.isNumber(item.value);
};

export default function MetricList({ chartDef, timeslice }) {
    const classes = useTooltipStyles();
    const numberNumbers = timeslice.items.filter((item) => _.isNumber(item.value)).length;
    if (timeslice.checkAllNull && numberNumbers === 0) {
        return (
            <tr>
                <td className={classes.noDataText} colSpan={3}>
                    <Trans>No data available</Trans>
                </td>
            </tr>
        );
    }
    return (
        <>
            {timeslice.items
                .filter((item) => !item.def.hidden || item.def.tooltip)
                .filter((item) => filterOutStatusBreakout(chartDef, item))
                .map((item) => {
                    const styles = item.status ? { backgroundColor: getStatusColor(item.status, 0.4) } : {};
                    return (
                        <tr key={`${item.def.key}:${item.def.label}`} className={classes.tooltipPoint} style={styles}>
                            <td>
                                <div
                                    className={classes.tooltipPointColorBox}
                                    style={{ backgroundColor: item.def.color }}
                                />
                            </td>
                            <td className={classes.tooltipPointLabel}>{item.def.label}:</td>
                            <td className={classes.tooltipPointValue}>{chartDefFormatter(item.def, item.value)}</td>
                        </tr>
                    );
                })}
        </>
    );
}
